import { PaletteColor, Theme } from "@mui/material";
import {
  Cohort,
  CohortMemberStatus,
  CohortStatus,
  Workflow,
  WorkflowStatus,
} from "generated-graphql/graphql";

export enum DisplayStatus {
  Waiting = "Waiting",
  Ready = "Ready",
}

export type MinimalCohort = Pick<Cohort, "status"> & {
  currentWorkflow?: Pick<Workflow, "status"> | null;
};

export type CohortDisplayStatus = WorkflowStatus | DisplayStatus;
export const getCohortDisplayStatus = (
  cohort: MinimalCohort
): CohortDisplayStatus => {
  if (cohort.status === CohortStatus.Open) {
    return DisplayStatus.Waiting;
  }

  if (
    !cohort.currentWorkflow?.status ||
    cohort.currentWorkflow.status === WorkflowStatus.NotStarted
  ) {
    return DisplayStatus.Ready;
  }

  return cohort.currentWorkflow.status;
};

export const statusToSx = (status: CohortDisplayStatus, theme: Theme) => {
  const statusToColorMap: Record<CohortDisplayStatus, PaletteColor | null> = {
    [DisplayStatus.Waiting]: null,
    [DisplayStatus.Ready]: theme.palette.info,
    [WorkflowStatus.NotStarted]: theme.palette.info,
    [WorkflowStatus.InProgress]: theme.palette.info,
    [WorkflowStatus.Completed]: theme.palette.success,
    [WorkflowStatus.Paused]: theme.palette.warning,
    [WorkflowStatus.Error]: theme.palette.error,
    [WorkflowStatus.Canceled]: theme.palette.warning,
  };
  const color = statusToColorMap[status];

  if (!color) {
    return null;
  }

  return {
    backgroundColor: `${color.light}20`,
    color: color.main,
    border: `1px solid ${color.main}`,
  };
};

export const memberStatusToSx = (status: CohortMemberStatus, theme: Theme) => {
  const statusToColorMap: Record<CohortMemberStatus, PaletteColor | null> = {
    [CohortMemberStatus.Ready]: theme.palette.success,
    [CohortMemberStatus.NotReady]: theme.palette.error,
    [CohortMemberStatus.NotParticipating]: null,
    [CohortMemberStatus.Unknown]: theme.palette.warning,
  };
  const color = statusToColorMap[status];

  if (!color) {
    return null;
  }

  return {
    backgroundColor: `${color.light}20`,
    color: color.main,
    border: `1px solid ${color.main}`,
  };
};
